// removed by extract-text-webpack-plugin
module.exports = {"Account":"Account__Account__1HQsl","RegisterHolder":"Account__RegisterHolder__3v78b","bounceIn":"Account__bounceIn__21-Aj","TitleHolder":"Account__TitleHolder__xU0kW","RegisterForm":"Account__RegisterForm__3SC4s","ForgotPasswordLink":"Account__ForgotPasswordLink__1tAHl","AccountHolder":"Account__AccountHolder__tGbLa","MyAccount":"Account__MyAccount__1b-y6","AdminArea":"Account__AdminArea__F6MqO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Account/Account.css
// module id = 370
// module chunks = 0